module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('xmain', {
    attrs: {
      "title": _vm.title,
      "url": _vm.url,
      "menu": _vm.menu,
      "tools": _vm.tools
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-4b15dc0a!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/StoreApp.vue
// module id = 221
// module chunks = 2